import React, { useContext, useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { AuthContext } from "../../../context/Authcontext";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
const base_url = process.env.REACT_APP_API_URL;
const MatchHistoryManage = () => {
 const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
 const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [permit, setPermit] = useState([]);
  const { getRoles } = useContext(AuthContext);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate()

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchRoles = async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");

    try {
      const roles = await getRoles(auth, role);

      roles.map((role) => {
        const values = Object.values(role);

        values[0].map((val) => {
          if (Object.keys(val).includes("matches")) {
            const permit = Object.values(val);

            setPermit(permit[0]);
          }
        });
      });
    } catch (error) {
      console.log("ert", error);
    }
  };

  
  const GetMyMatches = async (Type) => {
    // console.log("Fetching matches...");
    console.log("Type is", Type);
    setLoading(true); // ✅ Start loading before fetching data

    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.post(
        `${base_url}/api/webapi/admin/getBetMatchHistory`,{Type},
        {
          // ✅ Pass Type as a query parameter
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      console.log("response is " , response)

      const data = response?.data.data;

      console.log("data is " , data)
      setMatches(data || []);
      // console.log("Matches received:", data);
    } catch (error) {
      console.error("Error fetching matches:", error);
    } finally {
      setLoading(false); // ✅ Stop loading after API response (success or error)
    }
  };

  

  useEffect(() => {
    fetchRoles();
    GetMyMatches("Cricket");
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


//   const getAllBets = async () =>{
//     const response = await  axios.
//   }

  return (
    <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
 {/* <div className="container-fluid">
          <h5 className="m-0">EventID</h5>
        </div> */}
        <section className="content">
         

          <div
            id="myMatches"
            className="mt-2 tophead d-flex justify-content-between"
          >
            <div className="d-flex align-items-center cursor-pointer">
              <div
                className="p-2 mid"
                style={{ cursor: "pointer" }}
                onClick={() => GetMyMatches("Cricket")}
              >
                <img
                  src="/assets/images/crickball1.png"
                  height="20px"
                  width="20px"
                  alt="Cricket Ball"
                />
                Cricket
              </div>

              <div
                className="p-2 mid"
                style={{ cursor: "pointer" }}
                onClick={() => GetMyMatches("Tennis")}
              >
                <img
                  src="/assets/images/tennis1.png"
                  height="20px"
                  width="20px"
                  alt="Tennis Ball"
                />
                Tennis
              </div>

              <div
                className="p-2 mid"
                style={{ cursor: "pointer" }}
                onClick={() => GetMyMatches("Soccer")}
              >
                <img
                  src="/assets/images/soccer1.png"
                  height="19px"
                  width="19px"
                  alt="Soccer Ball"
                />
                Soccer
              </div>
            </div>

            <div className="d-flex gap-2 pb-1">
              {/* <button
                type="button"
                className={`btn btn-sm btn-primary px-3 py-1 ${
                  permit.includes("Add Matches") ? "d-block" : "d-none"
                }`}
              >
                Add Manual Match
              </button> */}
              <button
                type="button"
                className="btn btn-sm btn-primary refreshButton px-3 py-1"
                onClick={() => window.location.reload()} // Refresh the page on click
              >
                Refresh
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <table
              role="grid"
              className="table table-hover datatable table-striped mt-4"
            >
              <thead className="bg-dark text-light">
                <tr >
                  <th>Sport Name</th>
                  {/* <th>Event Name</th> */}
                  <th>Competition Name</th>
                  <th>Event Name</th>
                  {/* <th>Selection ID</th>
                  <th>Runner Name</th> */}

                  <th className="text-center" >Number of Bet</th>
                  <th className="text-center">Total Bet Amount</th>

                  {/* <th>Winner</th> */}
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {matches.length > 0 ? (
                  matches.map((match, index) => {
                    const eventParts = match.eventname
                      ? match.eventname.split(" v ")
                      : [];

                    return (
                      <tr key={index} onClick={()=> navigate(`/admin/getAllMatchBet/${match.eventId}`)} className="cursor-pointer">
                        <td>
                          <div>{match.sportname}</div>
                          <div className="text-bold">{match.eventname}</div>
                        </td>
                        <td>{match.competitionName}</td>
                        <td>{match.eventName}</td>
                        {/* <td>{match.selectionid}</td>
                        <td>{match.runnername}</td> */}
                        <td className="text-center">{match.totalBets}</td>
                        <td className="text-center">{match.totalAmount}</td>


                        {/* Radio Buttons for Event Name */}
                        {/* <td>{match.result}</td> */}

                        {/* Add & Update Buttons */}
                        {/* <td>
                          <button
                            className="btn btn-warning btn-sm ms-2"
                            onClick={() => submitMatchData(match)}
                            disabled={match.update_status === 1} // Disable button when update_status is 1
                          >
                            Update
                          </button>
                          
                        </td> */}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No matches available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>

            
       
      </div>
     
    </div>
  );
};

export default MatchHistoryManage;